import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO component. Renders <title>, meta description, keywords,
 * canonical, Open Graph and Twitter tags. Pass only what you want to
 * override — sensible Hayat defaults are applied otherwise.
 */
export default function Seo({
  title,
  description,
  keywords,
  canonicalPath,
  image,
  noindex = false,
  jsonLd,
}) {
  const SITE = "https://www.hayatcctv.com";
  const DEFAULT_IMAGE =
    "https://customer-assets.emergentagent.com/job_2f2a5c6d-ffbe-4c9e-b66b-c716d5df5ea0/artifacts/nwh0s5xz_logo4.jpg";

  const finalTitle = title
    ? `${title} | Hayat Security & Surveillance Nagpur`
    : "Best CCTV Installation in Nagpur | Hayat Security & Surveillance | Call +91 96738 78652";
  const finalDesc =
    description ||
    "Hayat Security is Nagpur's most trusted CCTV installation, commercial surveillance, networking and AMC partner. 15+ years experience · 10,000+ clients · 12,000+ projects across Sitabuldi, Dharampeth, Civil Lines & all of Nagpur. Call +91 96738 78652 for a free site visit.";
  const finalKeywords =
    keywords ||
    "best CCTV installation in Nagpur, CCTV installation Nagpur, commercial surveillance Sitabuldi, CCTV repair near me, CCTV AMC Nagpur, security camera Nagpur, IP camera installation Nagpur, networking solutions Nagpur, biometric attendance Nagpur, surveillance system installer Nagpur, dome camera installation, bullet camera Nagpur, PTZ camera Nagpur, Hayat CCTV, Hayat Security Nagpur";
  const finalCanonical = canonicalPath
    ? `${SITE}${canonicalPath.startsWith("/") ? canonicalPath : `/${canonicalPath}`}`
    : SITE;
  const finalImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      <meta name="keywords" content={finalKeywords} />
      <link rel="canonical" href={finalCanonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={finalCanonical} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:site_name" content="Hayat Security & Surveillance" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:image" content={finalImage} />

      {/* Optional per-page JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
